import { useQuery } from '@apollo/client';
import { makeStyles } from '@material-ui/core';
import CustomLayout from 'component/layout/custom_layout';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { useDispatch } from 'react-redux';
import { getMe } from 'redux/authentication/user_detail';
import themes from 'styles/themes';
import { CreateSection } from './sections/create-section';
import { StudioSection } from './sections/studio-section';
import { UpcomingStylingSection } from './sections/upcoming-styling-section';
const useStyles = makeStyles((theme) => ({
    buttonCreateStyle: {
        top: 76,
        position: 'absolute',
        left: 0,
        right: 0,
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
        width: 193,
        margin: '0 auto',
        background: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '29px ',
        padding: '10px 0px',
        textAlign: 'center',
        color: themes.palette.common.white,
        fontWeight: 600,
        fontSize: 16,
        fontFamily: 'PoppinsRegular',
        border: `1px solid ${themes.palette.common.white}`,
    },
    content: {
        position: 'absolute',
        bottom: '20%',
        width: '100%',
        textAlign: 'center',
    },
    buttonSuggest: {
        margin: '0 auto',
        width: 193,
        background: 'white',
        borderRadius: '29px',
        textAlign: 'center',
        padding: '10px 0px',
        color: themes.palette.primary.main,
        fontWeight: 400,
        fontSize: 16,
        fontFamily: 'PoppinsRegular',
        border: 'none',
    },
    backgroundHome: {
        background: themes.palette.primary.light,
        boxShadow: 'none',
    },
}));

function HomeStylist() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const onGetDataCustomerComplete = (response: any) => {
        dispatch(getMe(response?.me));
    };

    useQuery(USER_DETAIL, {
        onCompleted(response) {
            onGetDataCustomerComplete(response);
        },
        onError(error) {
            console.log('get data Failed: ', error);
        },
        fetchPolicy: 'cache-only',
    });

    return (
        <CustomLayout showSideBarBtn={true} className={classes.backgroundHome} isStylist={true}>
            <div id="main" style={{ overflow: 'auto', maxHeight: '100%' }}>
                <CreateSection />
                <UpcomingStylingSection />
                <StudioSection />
            </div>
        </CustomLayout>
    );
}

export default HomeStylist;
